<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{width: '800px',height: '600px' }"
  styleClass="p-fluid comunica-completamento-dialog"
  [showHeader]="false"
  (onHide)="hide()">

  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-check-circle header-icon"></i>
         <h2>Concludi la preparazione della richiesta per l'anno {{richiesta?.anno}}</h2>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        (click)="hide()">
      </button>
    </div>

    <div class="dialog-content">
      <div class="warning-message">
        <i class="pi pi-exclamation-triangle warning-icon"></i>
        <div class="warning-content">
          <h3>Attenzione</h3>
          <p>Questa operazione:</p>
          <ul>
            <li>Invierà automaticamente una email di notifica a UMVS</li>
            <li>Invierà una email di conferma al tuo indirizzo</li>
            <li>Non potrà essere annullata</li>
          </ul>
        </div>
      </div>
      <div class="field">
        <label for="note">Note</label>
        <textarea
          id="note"
          pInputTextarea
          [(ngModel)]="note"
          [rows]="3"
          placeholder="Inserisci eventuali note"
          style="width: 100%"></textarea>
      </div>


    </div>

    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-text"
        (click)="hide()">
      </button>
      <button
        pButton
        pRipple
        label="Conferma"
        icon="pi pi-check"
        class="p-button-success"
        (click)="save()">
      </button>
    </div>
  </div>
</p-dialog>
